import { collect } from "collect.js";
import md5 from "md5";
import Axios from "./Axios";
import GlobalEventBus from "../EventBus/GlobalEventBus";

// TODO: Remove these 3 lines
if (typeof window.pendingRequests === "undefined") {
    window.pendingRequests = collect({});
}

/**
 * @todo: Transform this class into a Singleton, which can keep track of its own pending requests without having to rely
 * on a global window var. See Axios for an example pattern.
 */
export default class ApiService {
    async request(method: string, url: string, options: any = {}) {
        if ((Axios.getInstance().defaults.headers as Record<string, any>).common["X-Daalder-Customer-Token"]) {
            return this._axiosRequest(method, url, options);
        } else {
            return this.waitForCustomerToken(method, url, options);
        }
    }

    async _axiosRequest(method: string, url: string, options: any) {
        let baseUrl = window.ajax_object.daalder_api_url.replace(/\/*$/, "");

        // Fix potential double slashes
        let targetUrl = baseUrl + "/" + url.replace(/^\/*/, "");

        // @ts-ignore TODO: REMOVE THIS TS-IGNORE
        return Axios.getInstance()[method](targetUrl, options);
    }

    _pendingRequestsKey(url: string, options: any = {}) {
        return url + md5(JSON.stringify(options));
    }

    async get(url: string, options: any = {}) {
        let key = this._pendingRequestsKey(url, options);

        if (window.pendingRequests.has(key)) {
            return window.pendingRequests.get(key);
        }

        let request = this.request("get", url, options);
        window.pendingRequests.put(key, request);

        request
            .then(() => {
                window.pendingRequests.forget(key);
            })
            .catch((error) => {
                window.pendingRequests.forget(key);
                throw error;
            });

        return request;
    }

    async post(url: string, options: any = {}) {
        return this.request("post", url, options);
    }

    async put(url: string, options: any = {}) {
        return this.request("put", url, options);
    }

    async delete(url: string) {
        return this.request("delete", url);
    }

    waitForCustomerToken(method: string, url: string, options: any) {
        return new Promise((resolve, reject) => {
            // TODO: Get rid of this or transform it to hook into the CustomerStore.
            GlobalEventBus.on("customerInfoUpdated", (data: any) => {
                this._axiosRequest(method, url, options)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        });
    }
}
